import style from '../style/Analysis.module.less';
import { Breadcrumb } from 'antd';

interface AnalysisHeaderProps {
  title: string[];
  rightNode?: React.ReactNode;
}
const AnalysisHeader: React.FC<AnalysisHeaderProps> = props => {
  return (
    <div className={style.header} data-class="header">
      <div>
        <img src={require('@/assets/imgs/examCenter/exam.svg').default} alt="" />
        <Breadcrumb
          separator=">"
        >
          {
            props.title.map((i, index) => <Breadcrumb.Item key={index}>{i}</Breadcrumb.Item>)
          }
        </Breadcrumb>
      </div>
      { props.rightNode }
    </div>
  );
};

export default AnalysisHeader;